import styled from 'styled-components'

import { Icon } from '../../../../core'

export const StyledEditIcon = styled(Icon)`
  margin-left: ${props => props.theme.spacings.small};
`
